import { useState } from "react";
import { supabase } from "../supabaseClient";
import { useNavigate } from "react-router-dom";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleReset = async (e) => {
    e.preventDefault();
    setMsg("");
    setError("");

    if (!email.trim()) {
      setError("Please enter your email.");
      return;
    }

    setLoading(true);

    try {
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: `${window.location.origin}/reset-password`,
      });

      if (error) throw error;

      setMsg("✅ Password reset email sent. Please check your inbox.");
    } catch (err) {
      setError(err.message || "Failed to send reset email");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0F0A24] text-white">
      <form
        onSubmit={handleReset}
        className="bg-[#11111f] border border-[#EB6AB5]/30 p-10 rounded-3xl w-full max-w-md space-y-5"
      >
        <h2 className="text-2xl font-bold text-pink-400 text-center">
          🔑 Forgot Password
        </h2>

        <input
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full p-3 rounded bg-[#11111f] border border-[#EB6AB5]/30"
        />

        {msg && <p className="text-green-400 text-sm">{msg}</p>}
        {error && <p className="text-red-400 text-sm">{error}</p>}

        <button
          type="submit"
          disabled={loading}
          className="w-full py-3 bg-[#EB6AB5] text-black rounded-full font-semibold"
        >
          {loading ? "Sending..." : "Send Reset Link"}
        </button>

        <button
          type="button"
          onClick={() => navigate("/login")}
          className="block w-full text-sm text-gray-400 hover:text-white text-center"
        >
          ← Back to login
        </button>
      </form>
    </div>
  );
}
